import ACTION from '../action_constant';
import {ajaxPost,ajaxGet,ajaxPostWithToken,ajaxGetWithToken} from '../util/ajax';
import API from '../api_config';
import cookie from '../util/cookie';

const profileActions = {
    viewProfile: (url_params) => {
        return (dispatch) => {
            return ajaxGetWithToken ({
                url: API.viewProfile + '?encryptedUserId=' + url_params.encryptedUserId,
                success: (data) => {
                    dispatch({
                        type: ACTION.PROFILE.ADD_PROFILE_DATA,
                        data: {
                            profileData: data
                        }
                    })
                },
                error: (error) => {

                }
            })
        }
    },
    getProfileReviews: (url_params) => {
        return (dispatch) => {
            return ajaxGetWithToken ({
                url: API.getProfileReviews + '?encryptedUserId=' + url_params.encryptedUserId + '&offset=' + url_params.offset + '&count=' + url_params.count,
                success: (successData) => {
                    dispatch({
                        type: ACTION.PROFILE.PROFILE_REVIEWS,
                        data: {
                            reviews: successData
                        }
                    })
                },
                error: (error) =>{

                }
            })
        }
    },
    updateProfile: (paramObj) => {
      return (dispatch) => {
        return ajaxPostWithToken({
            url : API.updateProfile,
            data: paramObj,
            success: (data) => {
              const profile = data;
              dispatch({
                type: ACTION.PROFILE.UPDATE_PROFILE,
                data : {
                  profile : profile
                }
              });
              dispatch({
                type: ACTION.UPDATE_AUTH,
                data : {
                  data : profile
                }
              });
          },
          error: (error) => {
          }
      });
    }
  },
  updatePassword: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
          url : API.updatePassword,
          data: paramObj,
          success: (data) => {
          },
          error: (error) => {
          }
      });
    }
  },
  sendFeedback:(paramObj) =>{
    return(dispatch) =>{
      return ajaxPostWithToken({
          url : API.sendFeedback,
          data: paramObj,
          success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  contactSupport:(paramObj) =>{
    return(dispatch) =>{
      return ajaxPostWithToken({
          url : API.contactSupport,
          data: paramObj,
          success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
   addPromoCode:(params) =>{
    return(dispatch) =>{
      return ajaxPostWithToken({
          url : API.applyPromoCode,
          data: params,
          success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  getAllNotifications: (url_params) => {
      return (dispatch) => {
          return ajaxGetWithToken ({
              url: API.getAllNotifications + '?type=' + url_params.type + '&count=' + url_params.count+ '&offset=' + url_params.offset,
              success: (successData) => {
                dispatch({
                  type: ACTION.PROFILE.GET_NOTIFICATIONS,
                  data :successData
                });
              },
              error: (error) =>{

              }
          })
      }
  },
  getAllNotificationsSettings: (url_params) => {  //account page
      return (dispatch) => {
          return ajaxGetWithToken ({
              url: API.getAllNotificationsSettings ,
              success: (successData) => {

              },
              error: (error) =>{

              }
          })
      }
  },
  setAllNotificationSettings : (params) =>{ //account page
    return(dispatch) =>{
      return ajaxPostWithToken({
          url : API.setAllNotificationSettings,
          data: params,
          success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  deleteNotification : (params) =>{
    return(dispatch) =>{
      return ajaxPostWithToken({
          url : API.deleteNotification,
          data: params,
          success: (data) => {
            dispatch({
              type: ACTION.PROFILE.DELETE_NOTIFICATIONS,
              data : params
            });
          },
        error: (error) => {
        }
      });
    }
  },
  readNotification : (params) =>{
    return(dispatch) =>{
      return ajaxPostWithToken({
          url : API.readNotification,
          data: params,
          success: (data) => {
            dispatch({
              type: ACTION.PROFILE.READ_NOTIFICATION,
              data : params
            });
          },
        error: (error) => {
        }
      });
    }
  }
}

export default profileActions;



// WEBPACK FOOTER //
// app/profile/profile_actions.jsx